import { DisclaimerTypes } from './../../interfaces/disclaimertypes';
import { Component } from '@angular/core';

@Component({
    selector: 'app-imprint',
    standalone: false,

    templateUrl: './imprint.component.html',
    styleUrl: './imprint.component.scss'
})
export class ImprintComponent {
    disclaimerTypes: DisclaimerTypes = DisclaimerTypes.PAGE_FOOTER;

}
